// extracted by mini-css-extract-plugin
export default {"cls1":"LookupTextField-Scrim_cls1__NymTP","cls2":"LookupTextField-Scrim_cls2__It7AK LookupTextField-Scrim_cls1__NymTP"};